export const getDurationSince = (startTime: number) =>
    Math.floor(window.performance.now() - startTime);

/** 与 MXLoginPage 一致：从 pageModuleEnterTime 计算模块停留/加载时长 */
export const getModuleDuration = (enterTime: number) =>
    Math.floor(window.performance.now() - (enterTime || 0));

export const getErrorTrackAttrs = (
    response: { errno?: number | string; error?: string } | null | undefined
) => ({
    error_code: response?.errno ?? 'request_error',
    error_msg: response?.error ?? 'request_error'
});
